var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container pt-5 page-pc mt-5 mt-md-0" },
    [
      _c("notifications", { attrs: { group: "foo", position: "top center" } }),
      _vm._v(" "),
      _c("router-view", { key: _vm.$route.fullPath })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }